import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";

export const changeBranchModal = ({
  t,
  user,
  sucsList,
  setModalData,
  switchBranch,
  closeMsg,
}: stdObject) => {
  return {
    title: t("c.Z3"),
    mainColor: colors.blue,
    blocked: true,
    inputListStyle: { height: 300 },
    table: sucsList
      .filter((e: stdObject) => e.CODSUC !== user.CODSUC)
      .map((e: stdObject, index: number) => {
        return {
          data: [e.NOMSUC],
          style: {
            textAlign: "center",
            backgroundColor: index % 2 === 0 ? colors.lightGrey : colors.white,
          },
          onClick: () => switchBranch(e.CODSUC),
        };
      }),
    buttons: [
      {
        label: t("p.cancel"),
        onClick: () => {
          closeMsg();
          setModalData({});
        },
        color: colors.darkGrey,
      },
    ],
  };
};
